
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "AddUser",
  computed: {
    ...mapState(["allUsers"]),
  },
  methods: {
    ...mapActions(["addGroupToAnyUser", "getAllUsersFromApi"]),
    async handleAddUserToGroup(userId: string) {
      this.addGroupToAnyUser({ groupId: this.$route.params.id, userId });
    },
  },

  mounted() {
    this.getAllUsersFromApi();
  },
});
